import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rosie-crm-integrations-banner',
  templateUrl: './crm-integrations-banner.component.html',
  styleUrls: ['./crm-integrations-banner.component.scss'],
  standalone: false,
})
export class CrmIntegrationsBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  constructor(private router: Router) {}

  dismiss(): void {
    this.dismissed.emit();
  }

  navigate(): void {
    this.router.navigate(['/integrations', { category: 'crm' }]);
  }
}
